import { Croupier } from 'game-logic';
import { GameServices } from '../../services/game-services';
import { RoundedLabelViewModel } from '../components/rounded-label-view-model';
import { CroupierCardStackViewModel } from './croupier-card-stack-view-model';
import { BlackjackStylesType } from '../../model/blackjack-types';

export class CroupierHandViewModel {
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get scoreText$() {
    return this.croupierScoreViewModel.currentText$;
  }

  public readonly croupierCardStackViewModel: CroupierCardStackViewModel;
  public readonly croupierScoreViewModel: RoundedLabelViewModel;

  constructor(private gameServices: GameServices) {
    this.croupierCardStackViewModel = new CroupierCardStackViewModel(gameServices);
    this.croupierScoreViewModel = new RoundedLabelViewModel(
      gameServices,
      '',
      gameServices.gameThemeService.getNumericalRGB(BlackjackStylesType.CardBackground),
      gameServices.gameThemeService.getNumericalAlpha(BlackjackStylesType.CardBackground),
    );
  }

  public resetGameScene() {
    this.croupierCardStackViewModel.resetGameScene();
    this.clearScore();
  }

  public updateScore(croupier: Croupier) {
    if (croupier.allFaceAndHiddenCards.length > 0) {
      this.croupierScoreViewModel.setText(croupier.displayScore);
    }
  }

  public clearScore(): void {
    this.croupierScoreViewModel.setText('');
  }
}
